import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid"],
  _excluded2 = ["valid"],
  _excluded3 = ["valid"],
  _excluded4 = ["valid"],
  _excluded5 = ["valid"],
  _excluded6 = ["valid"],
  _excluded7 = ["valid"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request.js";
import { getClientAppData } from "@/js/http/auth";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterIntegerKey, filterDecimalKey, filterDecimalKeyAllowNegative } from "@/js/events/keycodes.js";
import { getFullNameUser } from "@/js/user/user.js";
import { formatPrice, getSymbolCurrency, getCurrentRate, roundToTwoDigit } from "@/js/currency/currencies.js";
import { listCurrencies, listTerms, orderStatus, paymentState, creditNoteUse } from "@/js/lists.ts";
import OrderPaymentList from "@/components/order/AdminSummarySubs/Payments/OrderPaymentList.vue";
import OrderServicePresetSelect from "@/components/order/StandaloneOrders/OrderServicePresetSelect.vue";
import OrderCommunications from "@/components/order/AdminSummarySubs/OrderCommunications.vue";
import SendMailModal from "@/components/mail/SendMailModal.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultEntityAddForm = {
  userId: null,
  importerId: null,
  leftData: {
    title: "",
    nameLine: "",
    addressLine1: "",
    addressLine2: "",
    taxIdLine: "",
    permitLine: "",
    partnerLine3: "",
    partnerLine2: "",
    partnerLine1: "",
    phoneLine: ""
  },
  rightData: {
    title: "",
    nameLine: "",
    addressLine1: "",
    addressLine2: "",
    taxIdLine: "",
    permitLine: "",
    partnerLine3: "",
    partnerLine2: "",
    partnerLine1: "",
    phoneLine: ""
  },
  bottomData: {
    title: "",
    nameLine: "",
    addressLine1: "",
    addressLine2: "",
    taxIdLine: "",
    permitLine: "",
    partnerLine3: "",
    partnerLine2: "",
    partnerLine1: "",
    phoneLine: ""
  },
  currency: null,
  vatRate: null,
  term: listTerms.find(function (x) {
    return x.nbDays === 0;
  }).id,
  nature: "Services",
  items: [{
    quantity: 1,
    description: "",
    unitPriceExVatCurrency: 0.0
  }],
  valid: false
};
var defaultItemForm = {
  id: null,
  quantity: 1,
  description: "",
  unitPriceExVatCurrency: 0.0,
  valid: false
};
var defaultDataForm = {
  title: "",
  nameLine: "",
  addressLine1: "",
  addressLine2: "",
  taxIdLine: "",
  permitLine: "",
  partnerLine3: "",
  partnerLine2: "",
  partnerLine1: "",
  phoneLine: "",
  valid: false
};
var defaultConfigurationForm = {
  currency: null,
  vatRate: null,
  term: listTerms.find(function (x) {
    return x.nbDays === 0;
  }).id,
  nature: "Services",
  valid: false
};
export default {
  name: "AdminStandaloneOrderModal",
  components: {
    OrderPaymentList: OrderPaymentList,
    OrderServicePresetSelect: OrderServicePresetSelect,
    OrderCommunications: OrderCommunications,
    SendMailModal: SendMailModal,
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object,
    id: Number | null,
    importers: Array | null,
    users: Array | null
  },
  data: function data() {
    return {
      dialog: false,
      options: {
        zIndex: 2000
      },
      clientAppData: null,
      isAddingNewEntity: false,
      entity: {},
      gettingEntity: {
        isPending: false,
        cancellationToken: null
      },
      addingEntity: {
        isPending: false,
        cancellationToken: null,
        form: _objectSpread({}, defaultEntityAddForm)
      },
      updatingConfiguration: {
        isConfiguring: false,
        isPending: false,
        cancellationToken: null,
        form: _objectSpread({}, defaultConfigurationForm)
      },
      handlingItem: {
        adding: {
          isConfiguring: false,
          form: _objectSpread({}, defaultItemForm)
        },
        updating: {
          isConfiguring: false,
          form: _objectSpread({}, defaultItemForm)
        },
        saving: {
          isPending: false,
          cancellationToken: null
        },
        removing: {
          isPending: false,
          cancellationToken: null
        },
        getting: {
          isPending: false,
          cancellationToken: null
        }
      },
      changingUser: {
        isConfiguring: false,
        isPending: false,
        cancellationToken: null,
        form: {
          userId: null
        }
      },
      changingImporter: {
        isConfiguring: false,
        isPending: false,
        cancellationToken: null,
        form: {
          importerId: null
        }
      },
      updatingLeftData: {
        openedPanelIndex: null,
        isConfiguring: false,
        isPending: false,
        cancellationToken: null,
        form: _objectSpread({}, defaultDataForm)
      },
      updatingRightData: {
        openedPanelIndex: null,
        isConfiguring: false,
        isPending: false,
        cancellationToken: null,
        form: _objectSpread({}, defaultDataForm)
      },
      updatingBottomData: {
        openedPanelIndex: null,
        isConfiguring: false,
        isPending: false,
        cancellationToken: null,
        form: _objectSpread({}, defaultDataForm)
      },
      gettingInvoiceFile: {
        isPending: false,
        cancellationToken: null,
        isFetched: false,
        url: null
      },
      creatingInvoice: {
        isPending: false,
        cancellationToken: null
      },
      cancellingOrder: {
        isPending: false,
        cancellationToken: null
      },
      gettingUsers: {
        isPending: false,
        result: []
      },
      gettingImporters: {
        isPending: false,
        result: []
      },
      gettingCountries: {
        isPending: false,
        result: [],
        states: []
      },
      gettingPresetServices: {
        isPending: false,
        cancellationToken: null,
        result: []
      },
      selectingPresetService: {
        isConfiguring: false,
        itemIndex: null
      },
      gettingUsableCreditNotes: {
        isPending: false,
        cancellationToken: null,
        result: [],
        appliableHeaders: [{
          text: "Reference#",
          value: "numberLabel"
        }, {
          text: "Extra description",
          value: "extraDescription",
          width: "200px"
        }, {
          text: "Credit note date",
          value: "creationDate"
        }, {
          text: "Credit amount",
          value: "totalAmountCurrency"
        }, {
          text: "Credit available",
          value: "remaining.amountCurrency"
        }, {
          text: "",
          value: "maxAmountToCredit"
        }, {
          text: "Amount to credit",
          value: "amountToCredit"
        }]
      },
      applyingCreditNote: {
        isPending: false,
        cancellationToken: null
      },
      isUnselectingCreditNote: {},
      sendMailModalShown: false,
      listTerms: listTerms,
      listCurrencies: listCurrencies,
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isLoading: function isLoading() {
      return this.gettingEntity.isPending;
    },
    isEditable: function isEditable() {
      return this.entity && this.entity.status !== orderStatus.find(function (x) {
        return x.id === "CANCELLED";
      }).status;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isLoading || this.handlingItem.isPending || this.cancellingOrder.isPending || this.creatingInvoice.isPending || this.gettingInvoiceFile.isPending || this.handlingItem.getting.isPending || this.handlingItem.saving.isPending || this.handlingItem.removing.isPending || this.changingImporter.isPending || this.changingUser.isPending || this.updatingConfiguration.isPending || this.updatingLeftData.isPending || this.updatingRightData.isPending || this.updatingBottomData.isPending || this.addingEntity.isPending;
    },
    isAnySubformInProgress: function isAnySubformInProgress() {
      return this.handlingItem.adding.isConfiguring || this.handlingItem.updating.isConfiguring || this.changingImporter.isConfiguring || this.changingUser.isConfiguring || this.updatingConfiguration.isConfiguring || this.updatingLeftData.isConfiguring || this.updatingRightData.isConfiguring || this.updatingBottomData.isConfiguring;
    },
    isCancellable: function isCancellable() {
      var _this$entity, _this$entity2;
      return ((_this$entity = this.entity) === null || _this$entity === void 0 ? void 0 : _this$entity.id) && !((_this$entity2 = this.entity) !== null && _this$entity2 !== void 0 && _this$entity2.invoiceDate);
    },
    getCurrencies: function getCurrencies() {
      var prioritizedOrder = ["EUR", "USD"];
      return listCurrencies.filter(function (x) {
        return x.implanted_market;
      }).sort(function (a, b) {
        var indexA = prioritizedOrder.indexOf(a.id);
        var indexB = prioritizedOrder.indexOf(b.id);
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        } else if (indexA !== -1) {
          return -1;
        } else if (indexB !== -1) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    entityLeftDataHtml: function entityLeftDataHtml() {
      var html = "";
      if (this.entity.leftData.title) html += "<div>".concat(this.entity.leftData.title, ",</div>");
      if (this.entity.leftData.nameLine) html += "<div>".concat(this.entity.leftData.nameLine, ",</div>");
      if (this.entity.leftData.addressLine1) html += "<div>".concat(this.entity.leftData.addressLine1, ",</div>");
      if (this.entity.leftData.addressLine2) html += "<div>".concat(this.entity.leftData.addressLine2, ",</div>");
      if (this.entity.leftData.taxIdLine) html += "<div>".concat(this.entity.leftData.taxIdLine, ",</div>");
      if (this.entity.leftData.permitLine) html += "<div>".concat(this.entity.leftData.permitLine, ",</div>");
      if (this.entity.leftData.partnerLine3) html += "<div>".concat(this.entity.leftData.partnerLine3, ",</div>");
      if (this.entity.leftData.partnerLine2) html += "<div>".concat(this.entity.leftData.partnerLine2, ",</div>");
      if (this.entity.leftData.partnerLine1) html += "<div>".concat(this.entity.leftData.partnerLine1, ",</div>");
      if (this.entity.leftData.phoneLine) html += "<div>".concat(this.entity.leftData.phoneLine, ",</div>");
      return html;
    },
    entityRightDataHtml: function entityRightDataHtml() {
      var html = "";
      if (this.entity.rightData.title) html += "<div>".concat(this.entity.rightData.title, ",</div>");
      if (this.entity.rightData.nameLine) html += "<div>".concat(this.entity.rightData.nameLine, ",</div>");
      if (this.entity.rightData.addressLine1) html += "<div>".concat(this.entity.rightData.addressLine1, ",</div>");
      if (this.entity.rightData.addressLine2) html += "<div>".concat(this.entity.rightData.addressLine2, ",</div>");
      if (this.entity.rightData.taxIdLine) html += "<div>".concat(this.entity.rightData.taxIdLine, ",</div>");
      if (this.entity.rightData.permitLine) html += "<div>".concat(this.entity.rightData.permitLine, ",</div>");
      if (this.entity.rightData.partnerLine3) html += "<div>".concat(this.entity.rightData.partnerLine3, ",</div>");
      if (this.entity.rightData.partnerLine2) html += "<div>".concat(this.entity.rightData.partnerLine2, ",</div>");
      if (this.entity.rightData.partnerLine1) html += "<div>".concat(this.entity.rightData.partnerLine1, ",</div>");
      if (this.entity.rightData.phoneLine) html += "<div>".concat(this.entity.rightData.phoneLine, ",</div>");
      return html;
    },
    entityBottomDataHtml: function entityBottomDataHtml() {
      var html = "";
      if (this.entity.bottomData.title) html += "<div>".concat(this.entity.bottomData.title, ",</div>");
      if (this.entity.bottomData.nameLine) html += "<div>".concat(this.entity.bottomData.nameLine, ",</div>");
      if (this.entity.bottomData.addressLine1) html += "<div>".concat(this.entity.bottomData.addressLine1, ",</div>");
      if (this.entity.bottomData.addressLine2) html += "<div>".concat(this.entity.bottomData.addressLine2, ",</div>");
      if (this.entity.bottomData.taxIdLine) html += "<div>".concat(this.entity.bottomData.taxIdLine, ",</div>");
      if (this.entity.bottomData.permitLine) html += "<div>".concat(this.entity.bottomData.permitLine, ",</div>");
      if (this.entity.bottomData.partnerLine3) html += "<div>".concat(this.entity.bottomData.partnerLine3, ",</div>");
      if (this.entity.bottomData.partnerLine2) html += "<div>".concat(this.entity.bottomData.partnerLine2, ",</div>");
      if (this.entity.bottomData.partnerLine1) html += "<div>".concat(this.entity.bottomData.partnerLine1, ",</div>");
      if (this.entity.bottomData.phoneLine) html += "<div>".concat(this.entity.bottomData.phoneLine, ",</div>");
      return html;
    },
    totalAmount: function totalAmount() {
      var _this$entity3;
      return (_this$entity3 = this.entity) !== null && _this$entity3 !== void 0 && _this$entity3.items ? this.entity.items.reduce(function (acc, x) {
        return acc + x.amountCurrency;
      }, 0) : 0;
    },
    totalAmountExVat: function totalAmountExVat() {
      var _this$entity4;
      return (_this$entity4 = this.entity) !== null && _this$entity4 !== void 0 && _this$entity4.items ? this.entity.items.reduce(function (acc, x) {
        return acc + x.amountExVatCurrency;
      }, 0) : 0;
    },
    totalPaymentAmountCurrency: function totalPaymentAmountCurrency() {
      return this.entity.payments ? this.entity.payments.filter(function (x) {
        return x.state === paymentState.SUCCEEDED;
      }).reduce(function (acc, x) {
        return acc + x.amount;
      }, 0) : 0;
    },
    remainingPaymentAmount: function remainingPaymentAmount() {
      return roundToTwoDigit(this.totalAmount) - roundToTwoDigit(this.totalPaymentAmountCurrency);
    },
    isCreditNoteApplyAvailable: function isCreditNoteApplyAvailable() {
      if (this.gettingUsableCreditNotes.result.length > 0) {
        var amountToCredit = 0;
        this.gettingUsableCreditNotes.result.forEach(function (x) {
          if (x.amountToCredit) {
            amountToCredit += parseFloat(x.amountToCredit);
          }
        });
        if (amountToCredit > this.entity.total_amount_currency_include_credit_notes) {
          return false;
        }
        return !!amountToCredit;
      }
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.clientAppData = getClientAppData(_this2);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    confirmCancellingOrder: function confirmCancellingOrder() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$cancellingOrde;
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.cancellingOrder.isPending = true;
              (_this3$cancellingOrde = _this3.cancellingOrder.cancellationToken) === null || _this3$cancellingOrde === void 0 || _this3$cancellingOrde.cancel();
              _this3.cancellingOrder.cancellationToken = axios.CancelToken.source();
              _this = _this3;
              _context2.next = 6;
              return request("/v1/standalone-orders/".concat(_this3.entity.id), "delete", null, true, "api", null, _this.cancellingOrder.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.cancellingOrder.isPending = false;
                  _this.cancellingOrder.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to cancel the order", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 6:
              _context2.next = 8;
              return _this3.getEntity(_this3.entity.id);
            case 8:
              _this3.cancellingOrder.isPending = false;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    updateOrderWhenPaymentUpdated: function updateOrderWhenPaymentUpdated() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.getEntity(_this4.entity.id);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getCustomerAddress: function getCustomerAddress(userId) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _user$billing_address, _user$billing_address2, _user$billing_address3, _user$billing_address4, _user$billing_address5;
        var response, user, addressLine1, addressLine2;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return request("/v1/user/".concat(userId), "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Can't get complete customer");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 2:
              response = _context4.sent;
              user = _objectSpread({}, response.data);
              addressLine1 = user.billing_address.street;
              if (((_user$billing_address = user.billing_address.address_line_2) === null || _user$billing_address === void 0 ? void 0 : _user$billing_address.length) > 0) addressLine1 += " " + user.billing_address.address_line_2;
              if (((_user$billing_address2 = user.billing_address.address_line_3) === null || _user$billing_address2 === void 0 ? void 0 : _user$billing_address2.length) > 0) addressLine1 += " " + user.billing_address.address_line_3;
              addressLine2 = user.billing_address.country.printable_name;
              if (((_user$billing_address3 = user.billing_address.state) === null || _user$billing_address3 === void 0 || (_user$billing_address3 = _user$billing_address3.state_label) === null || _user$billing_address3 === void 0 ? void 0 : _user$billing_address3.length) > 0) addressLine2 += ", " + user.billing_address.state.state_label;
              if (((_user$billing_address4 = user.billing_address.city) === null || _user$billing_address4 === void 0 ? void 0 : _user$billing_address4.length) > 0) addressLine2 += ", " + user.billing_address.city;
              if (((_user$billing_address5 = user.billing_address.zip) === null || _user$billing_address5 === void 0 ? void 0 : _user$billing_address5.length) > 0) addressLine2 += " " + user.billing_address.zip;
              return _context4.abrupt("return", {
                title: "Billing",
                nameLine: getFullNameUser(user),
                addressLine1: addressLine1,
                addressLine2: addressLine2,
                taxIdLine: user.vat_code,
                permitLine: user.siren,
                partnerLine3: "",
                partnerLine2: "",
                partnerLine1: "",
                phoneLine: user.phone
              });
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    copyCustomerAddressInLeftData: function copyCustomerAddressInLeftData(userId) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var address;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5.getCustomerAddress(userId);
            case 2:
              address = _context5.sent;
              if (_this5.isAddingNewEntity) {
                _this5.addingEntity.form.leftData = _objectSpread({}, address);
              } else {
                _this5.updatingLeftData.form = _objectSpread({
                  valid: true
                }, address);
              }
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    copyCustomerAddressInRightData: function copyCustomerAddressInRightData(userId) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var address;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this6.getCustomerAddress(userId);
            case 2:
              address = _context6.sent;
              if (_this6.isAddingNewEntity) {
                _this6.addingEntity.form.rightData = _objectSpread({}, address);
              } else {
                _this6.updatingRightData.form = _objectSpread({
                  valid: true
                }, address);
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    copyCustomerAddressInBottomData: function copyCustomerAddressInBottomData(userId) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var address;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this7.getCustomerAddress(userId);
            case 2:
              address = _context7.sent;
              if (_this7.isAddingNewEntity) {
                _this7.addingEntity.form.bottomData = _objectSpread({}, address);
              } else {
                _this7.updatingBottomData.form = _objectSpread({
                  valid: true
                }, address);
              }
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getImporterAddress: function getImporterAddress(importerId) {
      var importer = this.importers.find(function (x) {
        return x.id === importerId;
      });
      return {
        title: "Seller",
        nameLine: importer.nameLine,
        addressLine1: importer.addressLine1,
        addressLine2: importer.addressLine2,
        taxIdLine: importer.taxIdLine,
        permitLine: importer.permitLine,
        partnerLine3: importer.partnerLine3,
        partnerLine2: importer.partnerLine2,
        partnerLine1: importer.partnerLine1,
        phoneLine: importer.phoneLine
      };
    },
    copyImporterAddressInLeftData: function copyImporterAddressInLeftData(importerId) {
      var address = this.getImporterAddress(importerId);
      if (this.isAddingNewEntity) {
        this.addingEntity.form.leftData = _objectSpread({}, address);
      } else {
        this.updatingLeftData.form = _objectSpread({
          valid: true
        }, address);
      }
    },
    copyImporterAddressInRightData: function copyImporterAddressInRightData(importerId) {
      var address = this.getImporterAddress(importerId);
      if (this.isAddingNewEntity) {
        this.addingEntity.form.rightData = _objectSpread({}, address);
      } else {
        this.updatingRightData.form = _objectSpread({
          valid: true
        }, address);
      }
    },
    copyImporterAddressInBottomData: function copyImporterAddressInBottomData(importerId) {
      var address = this.getImporterAddress(importerId);
      if (this.isAddingNewEntity) {
        this.addingEntity.form.bottomData = _objectSpread({}, address);
      } else {
        this.updatingBottomData.form = _objectSpread({
          valid: true
        }, address);
      }
    },
    eraseLeftData: function eraseLeftData() {
      if (this.isAddingNewEntity) {
        this.addingEntity.form.leftData = _objectSpread({}, defaultEntityAddForm.leftData);
      } else {
        this.updatingLeftData.form = _objectSpread({}, defaultDataForm);
      }
    },
    eraseRightData: function eraseRightData() {
      if (this.isAddingNewEntity) {
        this.addingEntity.form.rightData = _objectSpread({}, defaultEntityAddForm.rightData);
      } else {
        this.updatingRightData.form = _objectSpread(_objectSpread({}, defaultDataForm), {}, {
          valid: true
        });
      }
    },
    eraseBottomData: function eraseBottomData() {
      if (this.isAddingNewEntity) {
        this.addingEntity.form.bottomData = _objectSpread({}, defaultEntityAddForm.bottomData);
      } else {
        this.updatingBottomData.form = _objectSpread(_objectSpread({}, defaultDataForm), {}, {
          valid: true
        });
      }
    },
    addNewItem: function addNewItem() {
      var defaultItem = _objectSpread({}, defaultItemForm);
      if (this.isAddingNewEntity) {
        this.addingEntity.form.items.push(defaultItem);
      }
    },
    removeItemAdding: function removeItemAdding(index) {
      this.addingEntity.form.items.splice(index, 1);
    },
    startAddItem: function startAddItem() {
      this.handlingItem.adding.isConfiguring = true;
      this.handlingItem.adding.form = _objectSpread({}, defaultItemForm);
    },
    confirmAddItem: function confirmAddItem() {
      var _this$handlingItem$ad = this.handlingItem.adding.form,
        valid = _this$handlingItem$ad.valid,
        withoutValid = _objectWithoutProperties(_this$handlingItem$ad, _excluded);
      this.saveItem(withoutValid);
      this.cancelAddItem();
    },
    cancelAddItem: function cancelAddItem() {
      this.handlingItem.adding.isConfiguring = false;
      this.handlingItem.adding.form = _objectSpread({}, defaultItemForm);
    },
    startEditUser: function startEditUser() {
      this.changingUser.isConfiguring = true;
      this.changingUser.form = {
        userId: this.entity.user.id_user
      };
    },
    confirmEditUser: function confirmEditUser() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this8$changingUser$c;
        var _this;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this8.changingUser.isPending = true;
              (_this8$changingUser$c = _this8.changingUser.cancellationToken) === null || _this8$changingUser$c === void 0 || _this8$changingUser$c.cancel();
              _this8.changingUser.cancellationToken = axios.CancelToken.source();
              _this = _this8;
              _context8.next = 6;
              return request("/v1/standalone-orders/".concat(_this8.entity.id, "/user"), "put", _this8.changingUser.form, true, "api", null, _this.changingUser.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.changingUser.isPending = false;
                  _this.changingUser.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to change the user", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 6:
              _context8.next = 8;
              return _this8.getEntity(_this8.entity.id);
            case 8:
              _this8.fetchUsableCreditNotes();
              _this8.changingUser.isConfiguring = false;
              _this8.changingUser.form = {
                userId: null
              };
              _this8.changingUser.isPending = false;
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    cancelEditUser: function cancelEditUser() {
      this.changingUser.isConfiguring = false;
      this.changingUser.form = {
        userId: null
      };
    },
    startEditImporter: function startEditImporter() {
      this.changingImporter.isConfiguring = true;
      this.changingImporter.form = {
        importerId: this.entity.importer.id
      };
    },
    confirmEditImporter: function confirmEditImporter() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this9.changeImporter();
            case 2:
              _this9.cancelEditImporter();
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    cancelEditImporter: function cancelEditImporter() {
      this.changingImporter.isConfiguring = false;
      this.changingImporter.form = {
        importerId: null
      };
    },
    removeImporter: function removeImporter() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this10.changeImporter();
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    changeImporter: function changeImporter() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this11$changingImpor;
        var _this;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this11.changingImporter.isPending = true;
              (_this11$changingImpor = _this11.changingImporter.cancellationToken) === null || _this11$changingImpor === void 0 || _this11$changingImpor.cancel();
              _this11.changingImporter.cancellationToken = axios.CancelToken.source();
              _this = _this11;
              _context11.next = 6;
              return request("/v1/standalone-orders/".concat(_this11.entity.id, "/importer"), "put", _this11.changingImporter.form, true, "api", null, _this.changingImporter.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.changingImporter.isPending = false;
                  _this.changingImporter.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to change the importer", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 6:
              _context11.next = 8;
              return _this11.getEntity(_this11.entity.id);
            case 8:
              _this11.changingImporter.isPending = false;
            case 9:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    startEditLeftData: function startEditLeftData() {
      this.updatingLeftData.openedPanelIndex = 0;
      this.updatingLeftData.isConfiguring = true;
      this.updatingLeftData.form = _objectSpread(_objectSpread({}, defaultDataForm), this.entity.leftData);
    },
    confirmEditLeftData: function confirmEditLeftData() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this12$updatingLeftD;
        var _this12$updatingLeftD2, valid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this12.updatingLeftData.isPending = true;
              (_this12$updatingLeftD = _this12.updatingLeftData.cancellationToken) === null || _this12$updatingLeftD === void 0 || _this12$updatingLeftD.cancel();
              _this12.updatingLeftData.cancellationToken = axios.CancelToken.source();
              _this12$updatingLeftD2 = _this12.updatingLeftData.form, valid = _this12$updatingLeftD2.valid, withoutValid = _objectWithoutProperties(_this12$updatingLeftD2, _excluded2);
              _this = _this12;
              _context12.next = 7;
              return request("/v1/standalone-orders/".concat(_this12.entity.id, "/left-data"), "put", withoutValid, true, "api", null, _this.updatingLeftData.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.updatingLeftData.isPending = false;
                  _this.updatingLeftData.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to update bottom data", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 7:
              _this12.gettingInvoiceFile.isFetched = false;
              _this12.entity.leftData = _objectSpread({}, withoutValid);
              _this12.cancelEditLeftData();
              _this12.updatingLeftData.isPending = false;
            case 11:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    cancelEditLeftData: function cancelEditLeftData() {
      this.updatingLeftData.isConfiguring = false;
      this.updatingLeftData.form = _objectSpread({}, defaultDataForm);
    },
    startEditRightData: function startEditRightData() {
      this.updatingRightData.isOpened = true;
      this.updatingRightData.isConfiguring = true;
      this.updatingRightData.form = _objectSpread(_objectSpread({}, defaultDataForm), this.entity.rightData);
    },
    confirmEditRightData: function confirmEditRightData() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this13$updatingRight;
        var _this13$updatingRight2, valid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this13.updatingRightData.isPending = true;
              (_this13$updatingRight = _this13.updatingRightData.cancellationToken) === null || _this13$updatingRight === void 0 || _this13$updatingRight.cancel();
              _this13.updatingRightData.cancellationToken = axios.CancelToken.source();
              _this13$updatingRight2 = _this13.updatingRightData.form, valid = _this13$updatingRight2.valid, withoutValid = _objectWithoutProperties(_this13$updatingRight2, _excluded3);
              _this = _this13;
              _context13.next = 7;
              return request("/v1/standalone-orders/".concat(_this13.entity.id, "/right-data"), "put", withoutValid, true, "api", null, _this.updatingRightData.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.updatingRightData.isPending = false;
                  _this.updatingRightData.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to update bottom data", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 7:
              _this13.gettingInvoiceFile.isFetched = false;
              _this13.entity.rightData = _objectSpread({}, withoutValid);
              _this13.cancelEditRightData();
              _this13.updatingRightData.isPending = false;
            case 11:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    cancelEditRightData: function cancelEditRightData() {
      this.updatingRightData.isConfiguring = false;
      this.updatingRightData.form = _objectSpread({}, defaultDataForm);
    },
    startEditBottomData: function startEditBottomData() {
      this.updatingBottomData.isOpened = true;
      this.updatingBottomData.isConfiguring = true;
      this.updatingBottomData.form = _objectSpread(_objectSpread({}, defaultDataForm), this.entity.bottomData);
    },
    confirmEditBottomData: function confirmEditBottomData() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this14$updatingBotto;
        var _this14$updatingBotto2, valid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this14.updatingBottomData.isPending = true;
              (_this14$updatingBotto = _this14.updatingBottomData.cancellationToken) === null || _this14$updatingBotto === void 0 || _this14$updatingBotto.cancel();
              _this14.updatingBottomData.cancellationToken = axios.CancelToken.source();
              _this14$updatingBotto2 = _this14.updatingBottomData.form, valid = _this14$updatingBotto2.valid, withoutValid = _objectWithoutProperties(_this14$updatingBotto2, _excluded4);
              _this = _this14;
              _context14.next = 7;
              return request("/v1/standalone-orders/".concat(_this14.entity.id, "/bottom-data"), "put", withoutValid, true, "api", null, _this.updatingBottomData.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.updatingBottomData.isPending = false;
                  _this.updatingBottomData.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to update bottom data", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 7:
              _this14.gettingInvoiceFile.isFetched = false;
              _this14.entity.bottomData = _objectSpread({}, withoutValid);
              _this14.cancelEditBottomData();
              _this14.updatingBottomData.isPending = false;
            case 11:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    cancelEditBottomData: function cancelEditBottomData() {
      this.updatingBottomData.isConfiguring = false;
      this.updatingBottomData.form = _objectSpread({}, defaultDataForm);
    },
    startEditConfiguration: function startEditConfiguration() {
      this.updatingConfiguration.isConfiguring = true;
      this.updatingConfiguration.form = _objectSpread(_objectSpread({}, defaultConfigurationForm), {}, {
        currency: this.entity.currency,
        vatRate: +roundToTwoDigit((this.entity.vatRate - 1) * 100),
        nature: this.entity.nature,
        term: this.entity.term
      });
    },
    confirmEditConfiguration: function confirmEditConfiguration() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var _this15$updatingConfi;
        var _this15$updatingConfi2, valid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this15.updatingConfiguration.isPending = true;
              (_this15$updatingConfi = _this15.updatingConfiguration.cancellationToken) === null || _this15$updatingConfi === void 0 || _this15$updatingConfi.cancel();
              _this15.updatingConfiguration.cancellationToken = axios.CancelToken.source();
              _this15$updatingConfi2 = _this15.updatingConfiguration.form, valid = _this15$updatingConfi2.valid, withoutValid = _objectWithoutProperties(_this15$updatingConfi2, _excluded5);
              withoutValid.vatRate = +withoutValid.vatRate;
              _this = _this15;
              _context15.next = 8;
              return request("/v1/standalone-orders/".concat(_this15.entity.id, "/configuration"), "put", withoutValid, true, "api", null, _this.updatingConfiguration.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.updatingConfiguration.isPending = false;
                  _this.updatingConfiguration.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to update the configuration", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 8:
              _this15.gettingInvoiceFile.isFetched = false;
              _context15.next = 11;
              return _this15.getEntity(_this15.entity.id);
            case 11:
              _this15.updatingConfiguration.isConfiguring = false;
              _this15.updatingConfiguration.form = _objectSpread({}, defaultConfigurationForm);
              _this15.updatingConfiguration.isPending = false;
            case 14:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    cancelEditConfiguration: function cancelEditConfiguration() {
      this.updatingConfiguration.isConfiguring = false;
      this.updatingConfiguration.form = _objectSpread({}, defaultConfigurationForm);
    },
    startEditItem: function startEditItem(item) {
      this.handlingItem.updating.isConfiguring = true;
      this.handlingItem.updating.form = _objectSpread(_objectSpread({}, defaultItemForm), item);
    },
    confirmEditItem: function confirmEditItem() {
      var _this$handlingItem$up = this.handlingItem.updating.form,
        valid = _this$handlingItem$up.valid,
        withoutValid = _objectWithoutProperties(_this$handlingItem$up, _excluded6);
      this.saveItem(withoutValid);
      this.cancelEditItem();
    },
    cancelEditItem: function cancelEditItem() {
      this.handlingItem.updating.isConfiguring = false;
      this.handlingItem.updating.form = _objectSpread({}, defaultItemForm);
    },
    saveItem: function saveItem(item) {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var _this16$handlingItem$;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _this16.handlingItem.saving.isPending = true;
              (_this16$handlingItem$ = _this16.handlingItem.saving.cancellationToken) === null || _this16$handlingItem$ === void 0 || _this16$handlingItem$.cancel();
              _this16.handlingItem.saving.cancellationToken = axios.CancelToken.source();
              _this = _this16;
              _context16.next = 6;
              return request("/v1/standalone-orders/".concat(_this16.entity.id, "/items"), "post", item, true, "api", null, _this.handlingItem.saving.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.handlingItem.saving.isPending = false;
                  _this.handlingItem.saving.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to save the item", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 6:
              response = _context16.sent;
              _this16.gettingInvoiceFile.isFetched = false;
              if (response) {
                _this16.getItem(response.data.value);
              }
              _this16.handlingItem.saving.isPending = false;
            case 10:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    confirmRemoveItem: function confirmRemoveItem(item) {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return _this17.$refs.confirm.open("Confirm ?", "Are you sure to remove this item ?", {
                color: "red",
                width: 600
              });
            case 2:
              ok = _context17.sent;
              if (ok) {
                _this17.removeItem(item);
              }
            case 4:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    removeItem: function removeItem(item) {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this18$handlingItem$;
        var _this;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _this18.handlingItem.removing.isPending = true;
              (_this18$handlingItem$ = _this18.handlingItem.removing.cancellationToken) === null || _this18$handlingItem$ === void 0 || _this18$handlingItem$.cancel();
              _this18.handlingItem.removing.cancellationToken = axios.CancelToken.source();
              _this = _this18;
              _context18.next = 6;
              return request("/v1/standalone-orders/".concat(_this18.entity.id, "/items/").concat(item.id), "delete", null, true, "api", null, _this.handlingItem.removing.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.handlingItem.removing.isPending = false;
                  _this.handlingItem.removing.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to remove the item", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 6:
              _this18.gettingInvoiceFile.isFetched = false;
              _this18.entity.items.splice(_this18.entity.items.indexOf(item), 1);
              _this18.handlingItem.removing.isPending = false;
            case 9:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    getItem: function getItem(itemId) {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var _this19$handlingItem$;
        var _this, response, item;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _this19.handlingItem.getting.isPending = true;
              (_this19$handlingItem$ = _this19.handlingItem.getting.cancellationToken) === null || _this19$handlingItem$ === void 0 || _this19$handlingItem$.cancel();
              _this19.handlingItem.getting.cancellationToken = axios.CancelToken.source();
              _this = _this19;
              _context19.next = 6;
              return request("/v1/standalone-orders/".concat(_this19.entity.id, "/items/").concat(itemId), "get", null, true, "api", null, _this.handlingItem.getting.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.handlingItem.getting.isPending = false;
                  _this.handlingItem.getting.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to get the item", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 6:
              response = _context19.sent;
              if (response) {
                item = response.data.value;
                if (_this19.entity.items.some(function (x) {
                  return x.id == item.id;
                })) {
                  _this19.entity.items.splice(_this19.entity.items.findIndex(function (x) {
                    return x.id == item.id;
                  }), 1, item);
                } else {
                  _this19.entity.items.push(item);
                }
              }
              _this19.handlingItem.getting.isPending = false;
            case 9:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    createInvoice: function createInvoice() {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var _this20$creatingInvoi;
        var _this;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _this20.creatingInvoice.isPending = true;
              (_this20$creatingInvoi = _this20.creatingInvoice.cancellationToken) === null || _this20$creatingInvoi === void 0 || _this20$creatingInvoi.cancel();
              _this20.creatingInvoice.cancellationToken = axios.CancelToken.source();
              _this = _this20;
              _context20.next = 6;
              return request("/v1/standalone-orders/".concat(_this20.entity.id), "put", null, true, "api", null, _this.creatingInvoice.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.creatingInvoice.isPending = false;
                  _this.creatingInvoice.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to generate the invoice", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 6:
              _context20.next = 8;
              return _this20.getEntity(_this20.entity.id);
            case 8:
              _this20.getInvoiceFile();
              _this20.creatingInvoice.isPending = false;
            case 10:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    saveNewEntity: function saveNewEntity() {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var _this21$addingEntity$;
        var _this, _this21$addingEntity$2, valid, withoutValid, response;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _this21.addingEntity.isPending = true;
              (_this21$addingEntity$ = _this21.addingEntity.cancellationToken) === null || _this21$addingEntity$ === void 0 || _this21$addingEntity$.cancel();
              _this21.addingEntity.cancellationToken = axios.CancelToken.source();
              _this = _this21;
              _this21$addingEntity$2 = _this21.addingEntity.form, valid = _this21$addingEntity$2.valid, withoutValid = _objectWithoutProperties(_this21$addingEntity$2, _excluded7);
              _context21.next = 7;
              return request("/v1/standalone-orders", "post", withoutValid, true, "api", null, _this.addingEntity.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.addingEntity.isPending = false;
                  _this.addingEntity.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to save the draft", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 7:
              response = _context21.sent;
              if (!response) {
                _context21.next = 14;
                break;
              }
              _this21.resetData();
              _this21.addingEntity.form = _objectSpread({}, defaultEntityAddForm);
              _context21.next = 13;
              return _this21.getEntity(response.data.value);
            case 13:
              _this21.fetchUsableCreditNotes();
            case 14:
              _this21.addingEntity.isPending = false;
            case 15:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }))();
    },
    getEntity: function getEntity(id) {
      var _this22 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var _this22$gettingEntity;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _this22.gettingEntity.isPending = true;
              (_this22$gettingEntity = _this22.gettingEntity.cancellationToken) === null || _this22$gettingEntity === void 0 || _this22$gettingEntity.cancel();
              _this22.gettingEntity.cancellationToken = axios.CancelToken.source();
              _this = _this22;
              _context22.next = 6;
              return request("/v1/standalone-orders/".concat(id), "get", null, true, "api", null, _this.gettingEntity.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.gettingEntity.isPending = false;
                  _this.gettingEntity.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to get the order", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 6:
              response = _context22.sent;
              _this22.entity = _objectSpread({}, response.data.value);
              _this22.gettingEntity.isPending = false;
              _this22.gettingEntity.cancellationToken = null;
            case 10:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }))();
    },
    getInvoiceFile: function getInvoiceFile() {
      var _this23 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var _this23$entity, _this23$entity2;
        var _this23$gettingInvoic, _this24, response;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              if (!((_this23$entity = _this23.entity) !== null && _this23$entity !== void 0 && _this23$entity.id && (_this23$entity2 = _this23.entity) !== null && _this23$entity2 !== void 0 && _this23$entity2.invoiceDate)) {
                _context23.next = 10;
                break;
              }
              _this23.gettingInvoiceFile.isPending = true;
              (_this23$gettingInvoic = _this23.gettingInvoiceFile.cancellationToken) === null || _this23$gettingInvoic === void 0 || _this23$gettingInvoic.cancel();
              _this23.gettingInvoiceFile.cancellationToken = axios.CancelToken.source();
              _this24 = _this23;
              _context23.next = 7;
              return request("/v1/standalone-orders/".concat(_this23.entity.id, "/invoice"), "get", null, true, "api", null, _this23.gettingInvoiceFile.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this24.gettingInvoiceFile.isPending = false;
                  _this24.gettingInvoiceFile.cancellationToken = null;
                  var errorData = getErrorData(e, _this24.managedExceptions, "Unable to get the invoice pdf", true);
                  handleErrorData(_this24, errorData);
                  throw e;
                }
              });
            case 7:
              response = _context23.sent;
              if (response) {
                _this23.gettingInvoiceFile.isFetched = true;
                _this23.gettingInvoiceFile.url = response.data.value.url;
              }
              _this23.gettingInvoiceFile.isPending = false;
            case 10:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }))();
    },
    openInvoiceFile: function openInvoiceFile() {
      window.open(this.gettingInvoiceFile.url, "_blank");
    },
    fetchImporters: function fetchImporters() {
      var _this25 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var _this25$importers;
        var _this26, response;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _this25.gettingImporters.isPending = true;
              if (!(((_this25$importers = _this25.importers) === null || _this25$importers === void 0 ? void 0 : _this25$importers.length) > 0)) {
                _context24.next = 5;
                break;
              }
              _this25.gettingImporters.result = _this25.importers;
              _context24.next = 10;
              break;
            case 5:
              _this26 = _this25;
              _context24.next = 8;
              return request("/v1/importers/all", "post", {}, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this26.managedExceptions, "Unable to get importers", true);
                handleErrorData(_this26, errorData);
                _this26.gettingImporters.isPending = false;
                throw e;
              });
            case 8:
              response = _context24.sent;
              if (response) {
                _this25.gettingImporters.result = _toConsumableArray(response.data.value.items);
                _this25.gettingImporters.result.sort(function (a, b) {
                  return a.name.localeCompare(b.name);
                });
              }
            case 10:
              _this25.gettingImporters.isPending = false;
            case 11:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }))();
    },
    fetchUsers: function fetchUsers() {
      var _this27 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var _this27$users;
        var _this28, data, response;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _this27.gettingUsers.isPending = true;
              if (!(((_this27$users = _this27.users) === null || _this27$users === void 0 ? void 0 : _this27$users.length) > 0)) {
                _context25.next = 5;
                break;
              }
              _this27.gettingUsers.result = _this27.users;
              _context25.next = 12;
              break;
            case 5:
              _this28 = _this27;
              data = {
                user_group: ["USER", "HORECA", "WHOLESALER"],
                include_holding: true,
                include_archive: true
              };
              _context25.next = 9;
              return request("/v1/users", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this28.managedExceptions, "Unable to get users", true);
                handleErrorData(_this28, errorData);
                _this28.gettingUsers.isPending = false;
                throw e;
              });
            case 9:
              response = _context25.sent;
              _this27.gettingUsers.result = _toConsumableArray(response.data.users).map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  labelForList: _this28.fullNameUser(x)
                });
              });
              _this27.gettingUsers.result.sort(function (a, b) {
                if (a.active && !b.active || !a.archive && b.archive) return -1;
                if (!a.active && b.active || a.archive && !b.archive) return 1;
                return a.labelForList.localeCompare(b.labelForList);
              });
            case 12:
              _this27.gettingUsers.isPending = false;
            case 13:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    },
    fullNameUser: function fullNameUser(user) {
      var userSuffix = "";
      if (user.archive) {
        userSuffix += " (archived)";
      } else if (!user.active) {
        userSuffix += " (inactive)";
      }
      return getFullNameUser(user) + userSuffix;
    },
    fetchCountries: function fetchCountries() {
      var _this29 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _this29.gettingCountries.isPending = true;
              _this = _this29;
              _context26.next = 4;
              return request("/v1/countries?implantedMarket=true", "post", _this29.clientAppData, false, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get countries", true);
                handleErrorData(_this, errorData);
                _this.gettingCountries.isPending = false;
                throw e;
              });
            case 4:
              response = _context26.sent;
              if (response) {
                _this.listCountries = _toConsumableArray(response.data.countries);
                _this.listStates = _toConsumableArray(response.data.states);
              }
              _this29.gettingCountries.isPending = false;
            case 7:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      }))();
    },
    fetchServicePresets: function fetchServicePresets() {
      var _this30 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        var _this30$gettingPreset;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _this30.gettingPresetServices.isPending = true;
              (_this30$gettingPreset = _this30.gettingPresetServices.cancellationToken) === null || _this30$gettingPreset === void 0 || _this30$gettingPreset.cancel();
              _this30.gettingPresetServices.cancellationToken = axios.CancelToken.source();
              _this = _this30;
              _context27.next = 6;
              return request("/v1/standalone-orders/preset-services", "get", null, true, "api", null, _this.gettingPresetServices.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.gettingPresetServices.isPending = false;
                  _this.gettingPresetServices.cancellationToken = null;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to get the services", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 6:
              response = _context27.sent;
              _this30.gettingPresetServices.result = _toConsumableArray(response.data.value.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  display_name: "".concat(x.name).concat(x.defaultUnitPriceExVatEuro !== null ? " (".concat(formatPrice(x.defaultUnitPriceExVatEuro), " ").concat(getSymbolCurrency("EUR"), ")") : "")
                });
              }));
              _this30.gettingPresetServices.isPending = false;
              _this30.gettingPresetServices.cancellationToken = null;
            case 10:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }))();
    },
    startSelectingPresetServices: function startSelectingPresetServices(index) {
      this.selectingPresetService.isConfiguring = true;
      this.selectingPresetService.itemIndex = index;
    },
    confirmSelectingPresetServices: function confirmSelectingPresetServices(presetService) {
      var priceCurrency = presetService.defaultUnitPriceExVatEuro;
      if (this.isAddingNewEntity) {
        this.addingEntity.form.items[this.selectingPresetService.itemIndex].description = presetService.name;
        if (priceCurrency !== null) {
          if (!!this.addingEntity.form.currency) {
            priceCurrency = priceCurrency * getCurrentRate(this.addingEntity.form.currency);
          }
          if (!!this.addingEntity.form.vatRate) {
            priceCurrency = priceCurrency * (1 + this.addingEntity.form.vatRate / 100);
          }
          this.addingEntity.form.items[this.selectingPresetService.itemIndex].unitPriceCurrency = roundToTwoDigit(priceCurrency);
        }
      } else {
        if (priceCurrency != null) {
          if (!!this.entity.currency) {
            priceCurrency = priceCurrency * getCurrentRate(this.entity.currency);
          }
          if (!!this.entity.vatRate) {
            priceCurrency = priceCurrency * this.entity.vatRate;
          }
        }
        if (this.selectingPresetService.itemIndex === null) {
          this.handlingItem.adding.form.description = presetService.name;
          if (priceCurrency != null) this.handlingItem.adding.form.unitPriceCurrency = roundToTwoDigit(priceCurrency);
        } else {
          this.handlingItem.updating.form.description = presetService.name;
          if (priceCurrency != null) this.handlingItem.updating.form.unitPriceCurrency = roundToTwoDigit(priceCurrency);
        }
      }
      this.selectingPresetService.isConfiguring = false;
      this.selectingPresetService.itemIndex = null;
    },
    cancelSelectingPresetServices: function cancelSelectingPresetServices() {
      this.selectingPresetService.isConfiguring = false;
      this.selectingPresetService.itemIndex = null;
    },
    openSendMailModal: function openSendMailModal() {
      var _this31 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _this31.sendMailModalShown = true;
              _this31.$nextTick(function () {
                _this31.$refs.SendMailModal.open();
              });
            case 2:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      }))();
    },
    closeSendMailModal: function closeSendMailModal() {
      var _this32 = this;
      this.$nextTick(function () {
        _this32.sendMailModalShown = false;
      });
    },
    fetchUsableCreditNotes: function fetchUsableCreditNotes() {
      var _this33 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        var _this33$gettingUsable;
        var _entity, _this, response;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _this33.gettingUsableCreditNotes.isPending = true;
              (_this33$gettingUsable = _this33.gettingUsableCreditNotes.cancellationToken) === null || _this33$gettingUsable === void 0 || _this33$gettingUsable.cancel();
              _this33.gettingUsableCreditNotes.cancellationToken = axios.CancelToken.source();
              _entity = _objectSpread({}, _this33.entity);
              _this = _this33;
              _context29.next = 7;
              return request("/v1/credit-notes/usables?targetUserId=".concat(_entity.user.id_user), "get", null, true, "api", null, _this.gettingUsableCreditNotes.cancellationToken).catch(function (e) {
                _this.gettingUsableCreditNotes.isPending = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load usable credit notes.");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 7:
              response = _context29.sent;
              _this33.gettingUsableCreditNotes.result = response.data.value.items.map(function (item) {
                item.isSelected = false;
                item.isUsable = true;
                item.useId = null;
                item.notUsableMessage = "";
                item.amountToCredit = 0.0;
                item.maxAmountToCredit = item.remaining.amountCurrency;
                if (item.remaining.amountCurrency <= 0) {
                  item.isUsable = false;
                }
                if (item.uses !== null) {
                  item.uses.forEach(function (use) {
                    if (use.order !== null && use.status !== creditNoteUse.status.CANCELED) {
                      if (use.order.id == _entity.id) {
                        item.isSelected = true;
                        item.useId = use.id;
                      }
                    }
                  });
                }
                if (item.isUsable) {
                  var hasInitialVatRate = item.initialVatRate ? true : false;
                  var orderIsConcernedByVat = _entity.amountVat > 0;
                  if (hasInitialVatRate !== orderIsConcernedByVat || hasInitialVatRate && orderIsConcernedByVat && item.initialVatRate !== 1 + parseFloat((_entity.amountVatCurrency / _entity.amountExVatCurrency).toFixed(3))) {
                    item.isUsable = false;
                    if (hasInitialVatRate) {
                      if (item.initialVatRate.toFixed(2) == 1 + parseFloat((_entity.amountVatCurrency / _entity.amountExVatCurrency).toFixed(2))) {
                        item.isUsable = true;
                      }
                      item.notUsableMessage = "There is " + ((item.initialVatRate - 1) * 100).toFixed(1) + " % VAT on this credit note.";
                    } else {
                      item.notUsableMessage = "This credit note is without VAT.";
                    }
                  }
                }
                if (item.isUsable && item.initialCurrency !== _entity.currency) {
                  item.isUsable = false;
                  item.notUsableMessage = "The currency (" + item.initialCurrency + ") is not the same on the order.";
                }
                return _objectSpread({}, item);
              });
              _this33.gettingUsableCreditNotes.isPending = false;
            case 10:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }))();
    },
    setMaxAmountToCredit: function setMaxAmountToCredit(item) {
      item.amountToCredit = item.maxAmountToCredit;
      var amountToCredit = this.remainingPaymentAmount;
      this.gettingUsableCreditNotes.result.forEach(function (x) {
        if (x.amountToCredit && item.id !== x.id) {
          amountToCredit -= parseFloat(x.amountToCredit);
        }
      });
      if (amountToCredit < 0) {
        item.amountToCredit = 0;
      } else if (amountToCredit - item.amountToCredit < 0) {
        item.amountToCredit = amountToCredit;
      }
    },
    changeAmountToCredit: function changeAmountToCredit(item) {
      if (item.amountToCredit > item.remaining.amountCurrency) {
        item.amountToCredit = item.remaining.amountCurrency;
      }
      var amountToCredit = this.remainingPaymentAmount;
      this.gettingUsableCreditNotes.result.forEach(function (x) {
        if (x.amountToCredit && item.id !== x.id) {
          amountToCredit -= parseFloat(x.amountToCredit);
        }
      });
      if (amountToCredit < 0) {
        item.amountToCredit = 0;
      } else if (amountToCredit - item.amountToCredit < 0) {
        item.amountToCredit = amountToCredit;
      }
    },
    applyCreditNotes: function applyCreditNotes() {
      var _this34 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        var _this34$applyingCredi;
        var _this, uses, _this34$$refs$orderPa;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _this34.applyingCreditNote.isPending = true;
              (_this34$applyingCredi = _this34.applyingCreditNote.cancellationToken) === null || _this34$applyingCredi === void 0 || _this34$applyingCredi.cancel();
              _this34.applyingCreditNote.cancellationToken = axios.CancelToken.source();
              _this34.applyingCreditNote.isPending = true;
              _this = _this34;
              uses = _this34.gettingUsableCreditNotes.result.filter(function (x) {
                return x.amountToCredit && parseFloat(x.amountToCredit) > 0;
              }).map(function (x) {
                var item = {
                  id: x.id,
                  amountCurrency: parseFloat(x.amountToCredit),
                  orderId: _this.entity.id,
                  status: creditNoteUse.status.IN_PROGRESS
                };
                return item;
              });
              _context30.prev = 6;
              _context30.next = 9;
              return request("/v1/credit-notes/uses", "post", {
                uses: uses
              }, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 9:
              _context30.next = 11;
              return _this34.getEntity(_this34.entity.id);
            case 11:
              (_this34$$refs$orderPa = _this34.$refs.orderPaymentList) === null || _this34$$refs$orderPa === void 0 || _this34$$refs$orderPa.updatePayments(_this34.entity.payments);
              _context30.next = 16;
              break;
            case 14:
              _context30.prev = 14;
              _context30.t0 = _context30["catch"](6);
            case 16:
              _this34.fetchUsableCreditNotes();
              _this34.applyingCreditNote.isPending = false;
            case 18:
            case "end":
              return _context30.stop();
          }
        }, _callee30, null, [[6, 14]]);
      }))();
    },
    unselectCreditNote: function unselectCreditNote(value) {
      var _this35 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var ok, _this35$$refs$orderPa;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return _this35.$refs.confirm.open("Remove", "Are you sure you want to remove this credit of this order ?", {
                color: "red"
              });
            case 2:
              ok = _context31.sent;
              if (!ok) {
                _context31.next = 11;
                break;
              }
              _this35.isUnselectingCreditNote = _objectSpread(_objectSpread({}, _this35.isUnselectingCreditNote), {}, _defineProperty({}, value.id, true));
              _context31.next = 7;
              return _this35.removeCreditNote(value.creditNoteId, value.id);
            case 7:
              _context31.next = 9;
              return _this35.getEntity(_this35.entity.id);
            case 9:
              (_this35$$refs$orderPa = _this35.$refs.orderPaymentList) === null || _this35$$refs$orderPa === void 0 || _this35$$refs$orderPa.updatePayments(_this35.entity.payments);
              _this35.fetchUsableCreditNotes();
            case 11:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      }))();
    },
    removeCreditNote: function removeCreditNote(id, useId) {
      var _this36 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _this = _this36;
              _context32.next = 3;
              return request("/v1/credit-notes/".concat(id, "/uses/").concat(useId), "delete", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                handleErrorData(_this, errorData);
                _this.isUnselectingCreditNote = _objectSpread(_objectSpread({}, _this.isUnselectingCreditNote), {}, _defineProperty({}, useId, false));
                throw e;
              });
            case 3:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      }))();
    },
    creditNoteDetails: function creditNoteDetails(id) {
      var detailsRoute = "adminEditCreditNote";
      var routeParams = {};
      return {
        name: detailsRoute,
        params: {
          id: id,
          routeParams: routeParams
        }
      };
    },
    open: function open() {
      var _this37 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _this37.resetData();
              _this37.dialog = true;
              if (!(_this37.id > 0)) {
                _context33.next = 10;
                break;
              }
              _this37.isAddingNewEntity = false;
              _context33.next = 6;
              return _this37.getEntity(_this37.id);
            case 6:
              _this37.getInvoiceFile();
              _this37.fetchUsableCreditNotes();
              _context33.next = 12;
              break;
            case 10:
              _this37.isAddingNewEntity = true;
              _this37.addingEntity.form = _objectSpread({}, defaultEntityAddForm);
            case 12:
              _this37.fetchImporters();
              _this37.fetchUsers();
              _this37.fetchCountries();
              _this37.fetchServicePresets();
              return _context33.abrupt("return", new Promise(function (resolve, reject) {
                _this37.resolve = resolve;
                _this37.reject = reject;
              }));
            case 17:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }))();
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        if (!this.isAddingNewEntity && !this.gettingInvoiceFile.isFetched) {
          this.getInvoiceFile();
        }
        this.dialog = false;
        this.resetData();
        this.$emit("closed");
      }
    },
    resetData: function resetData() {
      this.isAddingNewEntity = false;
      this.entity = null;
    },
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice,
    getFullNameUser: getFullNameUser,
    filterIntegerKey: filterIntegerKey,
    filterDecimalKey: filterDecimalKey,
    filterDecimalKeyAllowNegative: filterDecimalKeyAllowNegative,
    filterVAutocomplete: filterVAutocomplete
  }
};